window.addEventListener("DOMContentLoaded",function(){
const tabsLinks = document.querySelectorAll(".tabs-child-container .mega-menu__item");
const tabs = document.querySelectorAll(".mega-menu-tab.ctm-mega-menu-item");

tabs.forEach(tab => {
    tab.addEventListener("click", function() {
        const clickedTabData = this.getAttribute('data-attribute');

        tabsLinks.forEach(link => {
            const linkData = link.getAttribute('data-attribute');
            if (clickedTabData === linkData) {
                link.classList.remove('visually-hidden');
            } else {
                link.classList.add('visually-hidden');
            }
        });

        tabs.forEach(t => t.removeAttribute('data-active'));
        this.setAttribute('data-active', 'true');
    });
});





const promo_swiper = new Swiper(".megamenu-promo-swiper", {
  direction: 'horizontal',
  allowSlidePrev: true,
  allowSlideNext: true,
  loop:true,
  slidesPerView: 1,
  slidesPerGroup: 1,
  spaceBetween: 0,
  draggable: true,
  breakpoints: {
    990: {
      slidesPerView: 1,
      slidesPerGroup: 1,
    },
    1050: {
      slidesPerView: 1.5,
      slidesPerGroup: 0.5,
    }
  }
});
})